module.exports = __webpack_public_path__ + "img/icon-unfold.d862cbb0.svg";